import React from 'react';
import * as S from './entity-badge.styles';

export interface IBadgeLabeledValueProps {
    prefix: string;
    value: React.ReactNode;
}

export const BadgeLabeledValue: React.FC<IBadgeLabeledValueProps> = ({ prefix, value }) => (
    <S.LabeledValue>
        <S.LabeledValuePrefix>{prefix}</S.LabeledValuePrefix>
        <S.LabeledValueText>{value}</S.LabeledValueText>
    </S.LabeledValue>
);
